document.documentElement.classList.remove('no-js');

const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);

function setOverlay(open, node, trigger) {
  node.hidden = !open;
  document.body.classList.toggle('drawer-open', open);
  trigger?.setAttribute('aria-expanded', String(open));
  if (open) requestAnimationFrame(() => $('input,button,a', $('dialog', node))?.focus());
  else trigger?.focus();
}

const mobileMenu = $('[data-mobile-menu]');
if (mobileMenu && mobileMenu.parentElement !== document.body) document.body.append(mobileMenu);
const menuOpen = $('[data-menu-open]');
const menuClose = $('[data-menu-close]');
const mobileMenuFocusable = () => $$('a[href],button:not([disabled])', mobileMenu).filter((node) => !node.hidden);
function setMobileMenu(open, restoreFocus = true) {
  if (!mobileMenu || !menuOpen) return;
  mobileMenu.classList.toggle('is-open', open);
  mobileMenu.setAttribute('aria-hidden', String(!open));
  document.body.classList.toggle('menu-open', open);
  menuOpen.setAttribute('aria-expanded', String(open));
  if (open) requestAnimationFrame(() => menuClose?.focus());
  else if (restoreFocus) menuOpen.focus();
}
menuOpen?.addEventListener('click', () => setMobileMenu(true));
menuClose?.addEventListener('click', () => setMobileMenu(false));
mobileMenu?.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab') return;
  const focusable = mobileMenuFocusable();
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
  else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
});
matchMedia('(min-width: 990px)').addEventListener?.('change', (event) => { if (event.matches) setMobileMenu(false, false); });

const searchDialog = $('[data-search-dialog]');
const searchOpen = $('[data-search-open]');
searchOpen?.addEventListener('click', () => setOverlay(true, searchDialog, searchOpen));
$('[data-mobile-search-open]')?.addEventListener('click', () => { setMobileMenu(false, false); searchOpen?.click(); });
$$('[data-search-close]').forEach((button) => button.addEventListener('click', () => setOverlay(false, searchDialog, searchOpen)));
let searchTimer;
$('#GlobalSearch')?.addEventListener('input', (event) => {
  clearTimeout(searchTimer);
  const query = event.target.value.trim();
  const results = $('[data-predictive-results]');
  if (query.length < 2) { results.innerHTML = ''; return; }
  searchTimer = setTimeout(async () => {
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=6`);
      const payload = await response.json();
      const suggestions = payload.resources?.results || {};
      const items = [...(suggestions.products || []), ...(suggestions.pages || []), ...(suggestions.articles || [])];
      results.innerHTML = items.map((item) => `<a href="${item.url}"><span>${item.title}</span><small>${item.type || item.resource_type || 'Result'}</small></a>`).join('') || '<p>No signals detected.</p>';
    } catch { results.innerHTML = '<p>Search signal temporarily unavailable.</p>'; }
  }, 250);
});

const header = $('[data-header]');
let lastY = 0;
addEventListener('scroll', () => { const y = scrollY; header?.classList.toggle('is-scrolled', y > 20); if (header?.dataset.hideOnScroll === 'true') header.classList.toggle('is-hidden', y > lastY && y > 180); lastY = y; }, { passive: true });

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: .08 });
  $$('.reveal').forEach((el) => observer.observe(el));
} else $$('.reveal').forEach((el) => el.classList.add('is-visible'));

if (matchMedia('(pointer:fine)').matches) {
  const dot = $('.cursor-dot');
  addEventListener('pointermove', (event) => { if (dot) dot.style.transform = `translate(${event.clientX}px,${event.clientY}px)`; }, { passive: true });
}

const cartDrawer = $('[data-cart-drawer]');
const cartOpen = $('[data-cart-open]');
cartOpen?.addEventListener('click', (event) => { event.preventDefault(); setOverlay(true, cartDrawer, cartOpen); });
$$('[data-cart-close]').forEach((button) => button.addEventListener('click', () => setOverlay(false, cartDrawer, cartOpen)));

async function refreshCart(open = true) {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer-content`);
  if (!response.ok) { location.href = '/cart'; return; }
  const html = await response.text();
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const content = $('[data-cart-drawer-content]');
  const replacement = $('[data-cart-drawer-content]', parsed);
  if (content && replacement) content.innerHTML = replacement.innerHTML;
  const cart = await fetch('/cart.js').then((result) => result.json());
  $$('[data-cart-count]').forEach((count) => count.textContent = cart.item_count);
  bindCartQuantities();
  if (open && cartDrawer) setOverlay(true, cartDrawer, cartOpen);
}

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form || !window.fetch) return;
  event.preventDefault();
  const button = $('[name="add"]', form) || $('button[type="submit"]', form);
  button?.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error((await response.json()).description || 'Unable to add item.');
    await refreshCart(document.body.dataset.cartDrawer !== 'false');
  } catch (error) { alert(error.message); }
  finally { button?.removeAttribute('aria-busy'); }
});

function bindCartQuantities() {
  $$('[data-cart-quantity]').forEach((input) => input.addEventListener('change', async () => {
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(input.dataset.line), quantity: Number(input.value) }) });
    refreshCart(true);
  }, { once: true }));
}
bindCartQuantities();

$$('[data-product-section]').forEach((section) => {
  const form = $('[data-product-form]', section);
  const select = $('[data-variant-select]', section);
  const variants = JSON.parse($('[data-product-json]', section)?.textContent || '[]');
  $$('input[type="radio"]', section).forEach((radio) => radio.addEventListener('change', () => {
    const options = $$('input[type="radio"]:checked', section).map((input) => input.value);
    const variant = variants.find((item) => item.options.every((option, index) => option === options[index]));
    if (!variant || !select) return;
    select.value = variant.id;
    const button = $('[name="add"]', form);
    if (button) button.disabled = !variant.available;
    $('[data-add-label]', form).textContent = variant.available ? 'Add to cargo' : 'Transmission lost';
    $('[data-add-price]', form).textContent = money(variant.price);
    const sku = $('[data-product-sku]', section); if (sku) sku.textContent = `SKU: ${variant.sku || '—'}`;
    history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  }));
});

function initializeProductGallery(gallery) {
  if (gallery.dataset.galleryInitialized === 'true') return;
  const media = $$('.product__media', gallery);
  const controls = $('[data-product-gallery-controls]', gallery.parentElement);
  if (media.length < 2 || !controls) return;
  gallery.dataset.galleryInitialized = 'true';
  const current = $('[data-gallery-current]', controls);
  const previous = $('[data-gallery-previous]', controls);
  const next = $('[data-gallery-next]', controls);
  let activeIndex = 0;
  const clampIndex = (index) => Math.max(0, Math.min(media.length - 1, index));
  const closestIndex = () => {
    const galleryLeft = gallery.getBoundingClientRect().left;
    return media.reduce((closest, item, index) => Math.abs(item.getBoundingClientRect().left - galleryLeft) < Math.abs(media[closest].getBoundingClientRect().left - galleryLeft) ? index : closest, 0);
  };
  const update = (index = closestIndex()) => {
    activeIndex = clampIndex(index);
    current.textContent = String(activeIndex + 1);
    previous.disabled = activeIndex === 0;
    next.disabled = activeIndex === media.length - 1;
  };
  const move = (direction) => {
    const targetIndex = clampIndex(activeIndex + direction);
    const galleryLeft = gallery.getBoundingClientRect().left;
    const targetLeft = gallery.scrollLeft + media[targetIndex].getBoundingClientRect().left - galleryLeft;
    update(targetIndex);
    gallery.scrollTo({ left: targetLeft, behavior: 'auto' });
  };
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  gallery.addEventListener('scroll', () => update(), { passive: true });
  addEventListener('resize', () => update(), { passive: true });
  update();
}

$$('[data-product-gallery]').forEach(initializeProductGallery);
document.addEventListener('shopify:section:load', (event) => {
  $$('[data-product-gallery]', event.target).forEach(initializeProductGallery);
});

$$('[data-sort-select]').forEach((select) => select.addEventListener('change', () => select.form.submit()));
$$('[data-filter-open]').forEach((button) => button.addEventListener('click', () => { const facets = $('[data-facets]', button.form); facets?.classList.add('is-open'); button.setAttribute('aria-expanded', 'true'); }));
$$('[data-filter-close]').forEach((button) => button.addEventListener('click', () => { const facets = button.closest('[data-facets]'); facets?.classList.remove('is-open'); $('[data-filter-open]', facets?.closest('form'))?.setAttribute('aria-expanded', 'false'); }));
$$('[data-copy-link]').forEach((button) => button.addEventListener('click', async () => { await navigator.clipboard.writeText(button.dataset.url); button.textContent = 'Copied'; }));

$$('product-recommendations').forEach(async (node) => { if (!node.dataset.url) return; const html = await fetch(node.dataset.url).then((response) => response.text()); const parsed = new DOMParser().parseFromString(html, 'text/html'); const replacement = $('product-recommendations', parsed); if (replacement?.innerHTML.trim()) node.innerHTML = replacement.innerHTML; });

$$('[data-community-feed]').forEach(async (section) => {
  const base = section.dataset.endpoint?.replace(/\/$/, '');
  if (!base || window.Shopify?.designMode) return;
  const kind = section.dataset.communityFeed;
  const root = $('[data-community-results]', section);
  const communityOrigin = base.replace(/\/api\/public$/, '');
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 6000);
  section.dataset.feedState = 'loading';
  root?.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(`${base}/${kind}?limit=${section.dataset.limit}&_=${Date.now()}`, { headers: { Accept: 'application/json' }, cache: 'no-store', signal: controller.signal });
    if (!response.ok) throw new Error();
    const data = await response.json();
    if (!Array.isArray(data.items)) throw new Error();
    if (!data.items.length) {
      root.innerHTML = `<p class="integration-note">${escapeHtml(section.dataset.emptyText || (kind === 'events' ? 'Nothing on the calendar yet. Check back soon.' : 'No discussions yet. Start the first conversation.'))}</p>`;
      section.dataset.feedState = 'empty';
      return;
    }
    const enabled = (name) => section.dataset[name] !== 'false';
    root.innerHTML = data.items.slice(0, Number(section.dataset.limit)).map((item, index) => kind === 'events'
      ? `<article class="event-card">${item.image ? `<a class="event-card__media" href="${safeUrl(item.url, communityOrigin)}" aria-label="${escapeHtml(item.title)}"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.imageAlt || item.title)}" loading="lazy" decoding="async"></a>` : ''}<div class="event-card__content">${enabled('showCategory') || enabled('showDate') ? `<p class="kicker">${enabled('showCategory') ? escapeHtml(item.category || 'EVENT') : ''}${enabled('showCategory') && enabled('showDate') ? ' / ' : ''}${enabled('showDate') ? escapeHtml(formatCommunityDate(item.date)) : ''}</p>` : ''}<h3><a href="${safeUrl(item.url, communityOrigin)}">${escapeHtml(item.title)}</a></h3>${enabled('showLocation') ? `<p>${escapeHtml(item.location || '')}</p>` : ''}<p>${escapeHtml(item.description || '')}</p></div></article>`
      : `<article class="discussion-row"><span>0${index + 1}</span><div>${enabled('showCategory') ? `<p class="kicker">${escapeHtml(item.category || 'COMMUNITY')}</p>` : ''}<h3><a href="${safeUrl(item.url, communityOrigin)}">${escapeHtml(item.title)}</a></h3>${enabled('showAuthor') ? `<p>${escapeHtml(item.author || '')}</p>` : ''}</div>${enabled('showReplies') ? `<div><strong>${Number(item.replies) || 0}</strong><small>${escapeHtml(section.dataset.repliesLabel || 'replies')}</small></div>` : ''}${enabled('showActivity') ? `<time>${escapeHtml(item.activity || '')}</time>` : ''}</article>`).join('');
    section.dataset.feedState = 'ready';
  } catch { section.dataset.feedState = 'unavailable'; if (root) root.innerHTML = `<p class="integration-note">${escapeHtml(section.dataset.unavailableText || 'Community content is temporarily unavailable. Please try again soon.')}</p>`; }
  finally { clearTimeout(timeout); root?.removeAttribute('aria-busy'); }
});

function escapeHtml(value = '') { const node = document.createElement('span'); node.textContent = String(value); return node.innerHTML; }
function safeUrl(value = '', base = location.origin) { try { const url = new URL(value, base); return ['http:', 'https:'].includes(url.protocol) && url.origin === new URL(base).origin ? url.href : '#'; } catch { return '#'; } }
function formatCommunityDate(value = '') { const date = new Date(value); return Number.isNaN(date.getTime()) ? String(value) : new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(date); }

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  if (searchDialog && !searchDialog.hidden) setOverlay(false, searchDialog, searchOpen);
  if (cartDrawer && !cartDrawer.hidden) setOverlay(false, cartDrawer, cartOpen);
  if (mobileMenu?.classList.contains('is-open')) setMobileMenu(false);
});
